/* Wuschelherz: aus snippets/wh-cart-datei.liquid ausgelagert (Perf 1, 2026-11-02). Änderungen hier, nicht im Snippet. */
  (() => {
    if (window.whCartDatei) return;
    const CFG = {
      vid: window.WH_DD_V[0],
      price: window.WH_DD_V[1],
      prop: 'Digitale Datei dazu (+9,95 € inkl. MwSt.)',
      consentKey: 'Zustimmung zur Digitalen Datei',
      gedenk: window.WH_DD_V[2],
      map: window.WH_DD_V[3],
      freeFrom: 7500,   // Versandprofil „Standard“: kostenlos ab 75 € (TOTAL_PRICE), sonst 5,99 €
      bundlePct: 10,
      consentText: 'Ich stimme ausdrücklich zu, dass Wuschelherz vor Ablauf der Widerrufsfrist mit der Bereitstellung der Digitalen Datei beginnt. Mir ist bekannt, dass ich dadurch mit Beginn der Bereitstellung mein Widerrufsrecht für die Datei verliere.'
    };
    // Herkunft der Sitzung (UTM, Werbe-Landeseite, angle) merkt seit 2026-10-29 snippets/wh-kampagne.liquid in
    // sessionStorage „wh-ads-src“; „Zweites Bild“ liest sie unten über session().
    const JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
    const getCart = () => fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then((r) => r.json());
    const cid = (i) => i.properties && i.properties._customization_id;
    const isFile = (i) => i.variant_id === CFG.vid;
    const isPrint = (i) => !isFile(i) && i.product_type === 'Poster' && !!cid(i);
    // Gedenk-Regel: kein Angebot bei Gedenkprodukten (Tag stil:andenken oder gedenk:ja, Liste aus Liquid)
    const offerOk = (i) => CFG.gedenk.indexOf(String(i.product_id)) === -1;
    const fileFor = (c, id) => c.items.find((a) => isFile(a) && a.properties && a.properties._tib_customization_id === id);
    const hasJa = (i) => String((i.properties || {})[CFG.prop] || '').toLowerCase() === 'ja';
    const clean = (props) => { const p = Object.assign({}, props); delete p[CFG.prop]; delete p[CFG.consentKey]; delete p._tib_addon_variant; return p; };
    const post = (url, body) => fetch(url, { method: 'POST', headers: JSONH, body: JSON.stringify(body) }).then((r) => { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });

    // Neu laden: Drawer neu zeichnen bzw. Warenkorbseite neu laden
    const refresh = (cart, open = true) => {
      try { if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'wh-cart-datei', cart }); } catch (e) {}
      if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open } }));
    };

    // Datei an eine Bildposition hängen (Warenkorb-Angebot und Kachel im Gestalter)
    const attach = async (item) => {
      const id = cid(item);
      const props = Object.assign({}, item.properties, { [CFG.prop]: 'Ja', [CFG.consentKey]: CFG.consentText, _tib_addon_variant: CFG.vid + ':1' });
      await post('/cart/change.js', { id: item.key, quantity: item.quantity, properties: props });
      window.whDdAdding = Date.now();   // wh-bundle-flow zählt das nicht als neues Bild
      try { await post('/cart/add.js', { items: [{ id: CFG.vid, quantity: 1, properties: { _tib_customization_id: id } }] }); }
      catch (e) {
        // Datei ließ sich nicht hinzufügen: Bild wieder auf ohne Datei setzen
        const c2 = await getCart(); const it2 = c2.items.find((i) => cid(i) === id && isPrint(i));
        if (it2) await post('/cart/change.js', { id: it2.key, quantity: it2.quantity, properties: clean(it2.properties) });
        throw e;
      }
    };
    // Kachel im Gestalter: nach „In den Warenkorb“ die neue Position per _customization_id finden (vorgemerkt in
    // sessionStorage, falls die Seite vorher wechselt, z. B. in der Sparpaket-Kette)
    const PEND = 'wh-dd-pending';
    const pending = () => { try { return JSON.parse(sessionStorage.getItem(PEND) || '[]').filter((p) => Date.now() - p.ts < 600000); } catch (e) { return []; } };
    const setPending = (list) => { try { sessionStorage.setItem(PEND, JSON.stringify(list)); } catch (e) {} };
    const addFor = async (id, opts = {}) => {
      const list = pending(); if (!list.some((p) => p.id === id)) { list.push({ id, ts: Date.now() }); setPending(list); }
      try {
        const c = await getCart(); const item = c.items.find((i) => isPrint(i) && cid(i) === id);
        if (item && !fileFor(c, id)) await attach(item);
        setPending(pending().filter((p) => p.id !== id));
        if (opts.refresh !== false) { cache = null; refresh(await getCart(), false); }
      } catch (e) {}
    };
    setTimeout(() => pending().forEach((p) => addFor(p.id)), 800);

    // ---------- Absicherung: Datei und Bild passen immer zusammen ----------
    const problems = (c) => {
      const fix = [];
      c.items.forEach((i) => {
        if (isFile(i)) {
          const id = i.properties && i.properties._tib_customization_id;
          const parent = id && c.items.find((p) => isPrint(p) && cid(p) === id);
          if (!parent) fix.push({ type: 'drop', key: i.key });
          else if (i.quantity > 1) fix.push({ type: 'one', key: i.key });
        } else if (isPrint(i) && hasJa(i) && !fileFor(c, cid(i))) {
          fix.push({ type: 'reset', key: i.key, qty: i.quantity, props: clean(i.properties) });
        }
      });
      return fix;
    };
    let guarding = false, guardAt = 0;
    const guard = () => {
      if (guarding || Date.now() - guardAt < 4000) return Promise.resolve(false);
      guarding = true; guardAt = Date.now();
      return getCart().then((c1) => {
        if (!problems(c1).length) return false;
        // Teeinblue legt Bild und Datei kurz nacheinander ab: erst handeln, wenn der Fehler nach 2 s noch besteht
        return new Promise((res) => setTimeout(res, 2000)).then(getCart).then(async (c) => {
          const fix = problems(c); if (!fix.length) return false;
          for (const f of fix) {
            if (f.type === 'drop') await post('/cart/change.js', { id: f.key, quantity: 0 });
            else if (f.type === 'one') await post('/cart/change.js', { id: f.key, quantity: 1 });
            else await post('/cart/change.js', { id: f.key, quantity: f.qty, properties: f.props });
          }
          return true;
        });
      }).then((changed) => { guarding = false; if (changed) getCart().then(refresh); return changed; })
        .catch(() => { guarding = false; return false; });
    };

    // ---------- Angebot unter jedem Bild ohne Datei ----------
    const ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="14" rx="2"/><path d="m3 15 5-5 4 4 3-3 6 6"/><path d="M8 21h8"/></svg>';
    const card = (key) => {
      const el = document.createElement('div'); el.className = 'wh-cdd'; el.dataset.key = key;
      el.innerHTML = '<button type="button" class="wh-cdd__toggle" aria-expanded="false">' + ICON + '<span>+ Als Datei dazu, <span class="wh-cdd__tp"></span></span></button>'
        + '<div class="wh-cdd__panel" hidden>'
        + '<p>Dein fertiges Motiv zusätzlich als Bilddatei, ohne Rahmen und ohne Wasserzeichen, zum Beispiel für Dein Handy oder ein Fotobuch. Nur für den privaten Gebrauch. Download über den Link in Deiner Bestellbestätigung, spätestens 24 Stunden nach Deiner Bestellung.</p>'
        + '<p class="wh-cdd__price"></p>'
        + '<label class="wh-cdd__consent"><input type="checkbox"><span></span></label>'
        + '<button type="button" class="wh-cdd__add">Datei hinzufügen</button>'
        + '<p class="wh-cdd__error" role="alert" hidden></p></div>';
      el.querySelector('.wh-cdd__price').innerHTML = '+<span></span> <small>inkl. MwSt.</small>';
      el.querySelector('.wh-cdd__price span').textContent = CFG.price;
      el.querySelector('.wh-cdd__tp').textContent = CFG.price;
      el.querySelector('.wh-cdd__consent span').textContent = CFG.consentText;
      return el;
    };
    // ---------- Zweites Bild ----------
    const PRODS = String(CFG.map || '').split(';').filter(Boolean).map((r) => { const [id, h, s, f, t] = r.split('|'); return { id, h, s, f, t: (t || '').split(' ').filter(Boolean) }; });
    const targetsFor = (item) => {
      const me = PRODS.find((p) => p.id === String(item.product_id));
      if (!me || !me.s) return [];
      const same = PRODS.filter((p) => p.s === me.s && p.f === me.f);
      const pick = (tier) => same.find((p) => p.t.length === 1 && p.t[0] === tier) || same.find((p) => p.t.indexOf(tier) > -1 && p.t.indexOf('mensch-tier') === -1);
      const out = [];
      [['hund', 'Hund'], ['katze', 'Katze']].forEach(([tier, label]) => {
        const p = pick(tier); if (!p) return;
        const neutral = p.t.length > 1 && tier !== 'hund';
        out.push({ label, handle: p.h, tier: neutral ? tier : '' });
      });
      return out;
    };
    const flat = (s) => String(s || '').toLowerCase().replace(/ß/g, 'ss').replace(/\s+/g, '');
    const paramsFor = (item) => {
      const o = {}; (item.options_with_values || []).forEach((x) => { o[flat(x.name)] = x.value; });
      const mat = flat(o.material || ''); const fr = flat(o.rahmen || ''); const gr = flat(o.groesse || o['grösse'] || o.grosse || '');
      const q = {};
      if (mat) q.material = mat.indexOf('lein') === 0 ? 'leinwand' : mat.indexOf('acryl') === 0 ? 'acryl' : 'poster';
      if (fr && fr !== 'default' && fr.indexOf('acryl') !== 0) q.rahmen = fr.indexOf('ohne') === 0 ? 'ohne' : fr.indexOf('schwarz') === 0 ? 'schwarz' : fr.indexOf('wei') === 0 ? 'weiss' : fr.indexOf('natur') === 0 ? 'natur' : fr.indexOf('dunkel') === 0 ? 'dunkel' : '';
      if (gr) q.groesse = gr.replace(/\(.*$/, '').replace(/cm$/, '');
      Object.keys(q).forEach((k) => { if (!q[k]) delete q[k]; });
      return { q, opts: (item.options_with_values || []).map((x) => x.value) };
    };
    const session = () => { try { return JSON.parse(sessionStorage.getItem('wh-ads-src') || 'null'); } catch (e) { return null; } };
    const goSecond = async (btn, item, t) => {
      btn.setAttribute('aria-busy', 'true');
      const { q, opts } = paramsFor(item);
      const u = new URL('/products/' + t.handle, location.origin);
      if (t.tier) u.searchParams.set('tier', t.tier);
      // gleiche Ausführung als Variante (Material, Rahmen, Größe stimmen zwischen Hund und Katze überein)
      try {
        const p = await fetch('/products/' + t.handle + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const v = (p.variants || []).find((x) => (x.options || []).join('|') === opts.join('|'));
        if (v) u.searchParams.set('variant', v.id);
      } catch (e) {}
      const src = session();
      // Werbe-Landeseite nur für Besucherinnen aus einer Anzeige (Lukas 2026-10-27): Landeseite, Klick-ID oder bezahltes utm_medium
      const utm = (src && src.utm) || {};
      const ad = !!(src && (src.ads || utm.gclid || utm.gbraid || utm.wbraid || utm.fbclid || utm.ttclid || /paid|cpc|ppc|display|^ads?$/i.test(utm.utm_medium || '')));
      if (ad) { u.searchParams.set('view', 'ads'); Object.keys(q).forEach((k) => u.searchParams.set(k, q[k])); }
      if (src && src.utm) Object.keys(src.utm).forEach((k) => u.searchParams.set(k, src.utm[k]));
      location.href = u.pathname + u.search;
    };
    const secondBlock = (c, item) => {
      const targets = targetsFor(item); if (!targets.length) return null;
      const el = document.createElement('div'); el.className = 'wh-c2b'; el.dataset.key = item.key;
      // Versandzeile nur, wenn das zweite Bild (gleiche Ausführung, 10 % auf beide) die Grenze erreicht und sie heute nicht erreicht ist
      const unit = item.final_price; const rest = c.total_price - item.final_line_price;
      const after = Math.round((item.final_line_price + unit) * (100 - CFG.bundlePct) / 100) + rest;
      const ship = c.total_price < CFG.freeFrom && after >= CFG.freeFrom;
      el.innerHTML = '<p class="wh-c2b__title">Noch ein Liebling?</p><p class="wh-c2b__text"></p><div class="wh-c2b__btns"></div>';
      el.querySelector('.wh-c2b__text').textContent = ship ? 'Mit einem zweiten Bild sparst Du 10 % auf beide und der Versand ist frei.' : 'Gestalte ein zweites Bild, 10 % auf beide.';
      targets.forEach((t) => {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'wh-c2b__btn'; b.textContent = t.label;
        b.addEventListener('click', () => goSecond(b, item, t));
        el.querySelector('.wh-c2b__btns').appendChild(b);
      });
      return el;
    };
    const rowsFor = (key) => [document.getElementById('CartDrawer-Item-' + key), document.getElementById('CartItem-' + key)].filter(Boolean);
    let cache = null, cacheAt = 0, painting = false;
    const paint = () => {
      if (painting) return; painting = true;
      const use = (c) => {
        cache = c; cacheAt = Date.now(); painting = false;
        const want = new Set();
        let bundleKey = null;
        const prints = c.items.filter(isPrint);
        // Gedenk-Regel: mit Andenken im Warenkorb kein Zusatzangebot
        // 2026-10-29: in der Gedenk-Sitzung (?gedenk=1) ebenfalls kein Zusatzangebot
        const memorial = prints.some((i) => !offerOk(i)) || !!(window.whGedenkS && window.whGedenkS());
        if (!memorial) {
          // (a) Datei als kleine Zeile, am ersten Bild ohne Datei
          const target = prints.find((i) => !hasJa(i) && !fileFor(c, cid(i)));
          if (target) want.add(target.key);
          // (b) bei genau einem Bild das zweite Bild (nicht, solange der Sparpaket-Ablauf schon läuft)
          if (prints.length === 1 && prints[0].quantity === 1 && !document.querySelector('.wh-bfc__next')) bundleKey = prints[0].key;
        }
        const hostOf = (row) => (row.tagName === 'LI' ? row : (row.querySelector('td') || row));
        want.forEach((key) => rowsFor(key).forEach((row) => {
          const host = hostOf(row);
          if (!host.querySelector(':scope > .wh-cdd')) host.appendChild(card(key));
        }));
        document.querySelectorAll('.wh-cdd').forEach((el) => { if (!want.has(el.dataset.key)) el.remove(); });
        document.querySelectorAll('.wh-cbo').forEach((el) => el.remove());
        document.querySelectorAll('.wh-c2b').forEach((el) => { if (el.dataset.key !== bundleKey || el.dataset.total !== String(c.total_price)) el.remove(); });
        if (bundleKey) {
          const it = prints[0];
          rowsFor(bundleKey).forEach((row) => {
            const host = hostOf(row); if (host.querySelector(':scope > .wh-c2b')) return;
            const el = secondBlock(c, it); if (!el) return;
            el.dataset.total = String(c.total_price);
            host.appendChild(el);
          });
        }
        c.items.forEach((i) => {
          if (!isFile(i)) return;
          const id = i.properties && i.properties._tib_customization_id;
          const parent = id && c.items.find((x) => isPrint(x) && cid(x) === id);
          rowsFor(i.key).forEach((row) => {
            row.classList.add('wh-cdd-file');
            // Datei direkt unter ihr Bild stellen (Shopify listet sie sonst darüber)
            const prow = parent && rowsFor(parent.key).find((r) => r.parentElement === row.parentElement);
            if (prow && prow.nextElementSibling !== row) prow.after(row);
          });
        });
      };
      if (cache && Date.now() - cacheAt < 1500) use(cache);
      else getCart().then(use).catch(() => { painting = false; });
    };

    const add = async (el) => {
      const err = el.querySelector('.wh-cdd__error'); const btn = el.querySelector('.wh-cdd__add');
      if (!el.querySelector('.wh-cdd__consent input').checked) { err.textContent = 'Bitte bestätige zuerst die Zustimmung, sonst können wir Dir die Datei nicht bereitstellen.'; err.hidden = false; return; }
      err.hidden = true; btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
      try {
        const c = await getCart(); const item = c.items.find((i) => i.key === el.dataset.key);
        if (!item || !isPrint(item)) throw new Error('Position nicht gefunden');
        await attach(item);
        cache = null; refresh(await getCart());
      } catch (e) {
        btn.disabled = false; btn.textContent = 'Datei hinzufügen';
        err.textContent = 'Das hat nicht geklappt. Bitte versuch es noch einmal.'; err.hidden = false;
      }
    };
    document.addEventListener('click', (e) => {
      const t = e.target.closest && e.target.closest('.wh-cdd__toggle, .wh-cdd__add'); if (!t) return;
      const el = t.closest('.wh-cdd');
      if (t.classList.contains('wh-cdd__toggle')) {
        const p = el.querySelector('.wh-cdd__panel'); p.hidden = !p.hidden; t.setAttribute('aria-expanded', String(!p.hidden));
      } else add(el);
    });

    // Datei entfernen: Teeinblue legt sie sofort wieder an, solange das Bild „Ja“ trägt (_tib_addon_variant, Test 2026-10-23).
    // Deshalb zuerst das Bild auf ohne Datei setzen, dann die Datei-Position entfernen.
    const removeFile = async (key) => {
      const c = await getCart(); const f = c.items.find((i) => i.key === key); if (!f || !isFile(f)) return;
      const id = f.properties && f.properties._tib_customization_id;
      const parent = id && c.items.find((x) => isPrint(x) && cid(x) === id);
      if (parent) await post('/cart/change.js', { id: parent.key, quantity: parent.quantity, properties: clean(parent.properties) });
      const c2 = await getCart(); const f2 = c2.items.find((i) => isFile(i) && (!id || (i.properties && i.properties._tib_customization_id === id)));
      if (f2) await post('/cart/change.js', { id: f2.key, quantity: 0 });
    };
    document.addEventListener('click', (e) => {
      const a = e.target.closest && e.target.closest('[data-index]');
      if (!a || !(a.matches('[is="cart-remove-button"], a[href*="/cart/change"]'))) return;
      const key = a.getAttribute('data-index') || ''; if (key.split(':')[0] !== String(CFG.vid)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      a.setAttribute('aria-disabled', 'true');
      removeFile(key).then(getCart).then((c) => { cache = null; refresh(c); }).catch(() => location.reload());
    }, true);

    // Drawer und Warenkorbseite werden vom Theme neu gezeichnet: danach Angebot einsetzen und prüfen
    let timer = 0;
    const kick = () => { clearTimeout(timer); timer = setTimeout(() => { paint(); guard(); }, 250); };
    const watch = () => {
      document.querySelectorAll(/^\/cart\/?$/.test(location.pathname) ? 'cart-drawer, main' : 'cart-drawer').forEach((root) => {
        if (root.dataset.whCdd) return; root.dataset.whCdd = '1';
        new MutationObserver((list) => {
          if (list.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && !n.classList.contains('wh-cdd') && (n.id || '').indexOf('Cart') !== -1 || (n.querySelector && n.querySelector('[id^="CartDrawer-Item-"], [id^="CartItem-"]'))))) { cache = null; kick(); }
        }).observe(root, { childList: true, subtree: true });
      });
      if (document.querySelector('[id^="CartDrawer-Item-"], [id^="CartItem-"]')) kick();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    window.whCartDatei = { paint, guard, addFor, price: CFG.price, consentText: CFG.consentText };
  })();
